import script from "./ColorMng.vue?vue&type=script&setup=true&name=ColorMng&lang=js"
export * from "./ColorMng.vue?vue&type=script&setup=true&name=ColorMng&lang=js"

const __exports__ = script;

export default __exports__